import React from "react";
import { Link } from "react-router-dom";
import CookieNotice from "../components/CookieNotice";
import { useState } from "react";

export default function Landing() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="bg-white text-black">
      {/* Главен видео банер */}
      <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-md px-6 py-4">
        <div className="relative max-w-7xl mx-auto w-full flex items-center justify-between">

          {/* Десктоп + таблет: навигация + бутони + центрирано лого */}
          <div className="hidden md:flex w-full items-center justify-between relative">
            
            {/* Навигация – ляво */}
            <nav className="flex gap-6 text-sm font-semibold text-[#140D4F]">
              <a href="#how-it-works" className="hover:text-[#0267C1]">How It Works</a>
              <a href="#pricing" className="hover:text-[#0267C1]">Pricing</a>
              <a href="#brands" className="hover:text-[#0267C1]">Supported Brands</a>
            </nav>

            {/* Лого – абсолютно позиционирано в центъра */}
            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <a href="#top">
                <img
                  src="/logo.png"
                  alt="DiagCode.AI Logo"
                  className="h-7 sm:h-10 md:h-16 lg:h-20 max-w-[220px] object-contain"
                />
              </a>
            </div>

            {/* Бутони – дясно */}
            <div className="flex gap-3">
              <Link to="/login" className="px-4 py-2 text-sm font-semibold text-white bg-[#140D4F] hover:bg-[#0f0a3c] rounded">Login</Link>
              <Link to="/register" className="px-4 py-2 text-sm font-semibold text-white bg-[#FD5003] hover:bg-[#e34700] rounded">Register</Link>
            </div>
          </div>

          {/* Мобилно: ☰ меню отляво и логото в центъра */}
          <div className="flex items-center justify-between w-full md:hidden relative">
            
            {/* ☰ бутон */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="text-white bg-[#140D4F] hover:bg-[#0e083a] p-2 rounded-md shadow-md transition-colors"
            >
              ☰
            </button>

            {/* Центрирано лого */}
            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <a href="#top">
                <img
                  src="/logo.png"
                  alt="DiagCode.AI Logo"
                  className="h-7 sm:h-10 md:h-16 lg:h-20 max-w-[220px] object-contain"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Мобилно меню */}
        {mobileOpen && (
          <div className="md:hidden fixed top-0 left-0 w-64 h-full bg-white z-40 shadow-lg p-6 flex flex-col gap-6">
            <button onClick={() => setMobileOpen(false)} className="text-right text-xl text-[#140D4F] mb-4">✕</button>
            <nav className="flex flex-col gap-4 text-[#140D4F] font-semibold">
              <a href="#how-it-works" className="hover:text-[#0267C1]">How It Works</a>
              <a href="#pricing" className="hover:text-[#0267C1]">Pricing</a>
              <a href="#brands" className="hover:text-[#0267C1]">Supported Brands</a>
            </nav>
            <div className="flex flex-col gap-3 mt-6">
              <Link to="/login" className="w-full text-center py-2 bg-[#140D4F] text-white rounded font-semibold">Login</Link>
              <Link to="/register" className="w-full text-center py-2 bg-[#FD5003] text-white rounded font-semibold">Register</Link>
            </div>
          </div>
        )}
      </header>

{/* Video banner */}
<div id="top" className="w-full relative">
  <div className="relative w-full h-[600px] overflow-hidden">
    <img
      src="/site banners/ai_2304x1152.jpg"
      alt="DiagCode.AI Banner"
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 flex justify-start items-center bg-black/40 px-6 md:px-20 text-white">
      <div className="w-full max-w-3xl text-left space-y-6 pl-10 md:pl-20">
        <p className="text-2xl md:text-4xl font-bold leading-tight">
          Effortless Repairs with <br className="hidden sm:inline" />
          AI-Powered Step-by-Step Guidance
        </p>
        <p className="text-base md:text-lg leading-relaxed">
          Get expert AI-powered repair help instantly, guiding you through every task with ease and accuracy. No more frustration or wasted time – just reliable solutions whenever you need them.
        </p>
        <div>
          <Link
            to="/register"
            className="inline-block px-6 py-2 bg-[#FD5003] hover:bg-[#e34700] rounded-md font-semibold text-white"
          >
            See It in Action
          </Link>
        </div>
      </div>
    </div>
  </div>
</div>

           {/* Основни предимства */}
           <section className="bg-white text-black py-20 px-6">
            <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-12 text-center">
              <div className="bg-[#140D4F] hover:bg-[#0267C1] transition p-6 rounded-2xl shadow-xl text-white">
                <div className="mb-[4px]">
                  <img src="/icon/i1.png" alt="Precise Icon" className="h-24 w-24 mx-auto" />
                </div>
                <h3 className="text-lg font-semibold mb-2">Precision You Can Trust</h3>
                <p className="text-sm">
                  Get crystal-clear, detailed instructions that help you avoid costly mistakes and unexpected setbacks, ensuring every repair goes smoothly the first time.
                </p>
              </div>

              <div className="bg-[#140D4F] hover:bg-[#0267C1] transition p-6 rounded-2xl shadow-xl text-white">
                <div className="mb-[4px]">
                  <img src="/icon/i2.png" alt="Effortless Icon" className="h-24 w-24 mx-auto" />
                </div>
                <h3 className="text-lg font-semibold mb-2">Effortless Repairs Made Simple and Stress-Free</h3>
                <p className="text-sm">
                  DiagCode.AI’s AI-powered guidance breaks down complex tasks into clear, easy-to-follow steps—making repairs faster, smoother, and stress-free.
                </p>
              </div>

              <div className="bg-[#140D4F] hover:bg-[#0267C1] transition p-6 rounded-2xl shadow-xl text-white">
                <div className="mb-[4px]">
                  <img src="/icon/i3.png" alt="Efficient Icon" className="h-24 w-24 mx-auto" />
                </div>
                <h3 className="text-lg font-semibold mb-2">Efficiency That Boosts Your Productivity</h3>
                <p className="text-sm">
                  Eliminate hassle and confusion with smart guidance that helps you save time and energy—so you can focus on what truly matters.
                </p>
              </div>
            </div>
          </section>

           {/* How it Works? */}
           <section id="how-it-works" className="bg-white text-black py-12 px-6">
  <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-start">
    {/* Лява част с текст */}
    <div>
      <h2 className="text-4xl font-bold mb-6 text-[#140D4F]">How It Works</h2>
      <div className="space-y-8">
        <div className="flex items-start gap-4">
          <div className="text-2xl text-[#FD5003] font-bold">1</div>
          <div>
            <h3 className="text-xl font-semibold mb-1">Ask a question</h3>
            <p className="text-gray-700">Describe your specific repair task or question.</p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <div className="text-2xl text-[#FD5003] font-bold">2</div>
          <div>
            <h3 className="text-xl font-semibold mb-1">Get detailed instructions</h3>
            <p className="text-gray-700">Receive a detailed, step-by-step instruction guide with visuals.</p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <div className="text-2xl text-[#FD5003] font-bold">3</div>
          <div>
            <h3 className="text-xl font-semibold mb-1">Fix with confidence</h3>
            <p className="text-gray-700">Follow the precise AI guidance for a professional-grade repair.</p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <div className="text-2xl text-[#FD5003] font-bold">4</div>
          <div>
            <h3 className="text-xl font-semibold mb-1">Speak your language</h3>
            <p className="text-gray-700">
              Communicate with DiagCode.AI in <span className="text-black font-semibold">any language</span> — no need to write in English only.
              Type in your native language and receive instructions instantly.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-10">
        <Link
          to="/register"
          className="inline-block px-6 py-3 bg-[#FD5003] hover:bg-[#e34800] text-white rounded-md font-semibold transition"
        >
          Get Started
        </Link>
      </div>
    </div>

    {/* Дясна част с видео */}
    <div className="relative w-full h-[480px] rounded-xl overflow-hidden shadow-2xl border border-gray-300">
      <video
        autoPlay
        muted
        loop
        playsInline
        className="w-full h-full object-cover"
      >
        <source src="/videos/0502.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</section>

      {/* Pricing */}
      <section id="pricing" className="bg-white text-black py-12 px-6">
  <div className="max-w-7xl mx-auto text-center">
    <h2 className="text-4xl font-bold mb-12 text-[#140D4F]">Pricing</h2>
    <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      {[
        {
          title: "1 Hour Access",
          description: "Instant access for 1 hour.",
          price: "15€",
          color: "bg-[#140D4F] text-white"
        },
        {
          title: "1 Day Access",
          description: "Full access for 24 hours.",
          price: "55€",
          color: "bg-[#0267C1] text-white"
        },
        {
          title: "1 Week Access",
          description: "Access for 7 days.",
          price: "205€",
          color: "bg-[#B2D336] text-black"
        },
        {
          title: "1 Month Access",
          description: "Access for 30 days.",
          price: "560€",
          color: "bg-[#6C2BD9] text-white"
        },
        {
          title: "1 Year Access",
          description: "Best value: 1 year full access.",
          price: "1900€",
          color: "bg-[#FD5003] text-white"
        }
      ].map((plan, idx) => (
        <div
          key={idx}
          className={`rounded-2xl shadow-lg p-6 flex flex-col justify-between transition transform hover:scale-[1.03] ${plan.color}`}
        >
          <div>
            <h3 className="text-2xl font-semibold mb-2">{plan.title}</h3>
            <p className="text-sm opacity-90 mb-4">{plan.description}</p>
            <p className="text-3xl font-bold">{plan.price}</p>
          </div>
          <Link
            to="/register"
            className="mt-6 inline-block bg-white text-black font-semibold py-2 rounded hover:bg-gray-100 transition"
          >
            Get Started
          </Link>
        </div>
      ))}
    </div>
  </div>
</section>

            {/* Supported Brands */}
            <section id="brands" className="bg-white text-black py-12 px-6">
              <div className="max-w-7xl mx-auto text-center">
                <h2 className="text-4xl font-bold mb-12 text-[#140D4F]">Supported Brands</h2>

                {/* Единна мрежа за 2 реда, за да са идентични отстоянията */}
                <div className="grid md:grid-cols-3 gap-6">
                  {/* McLaren 720s - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/mclaren_720s_1.png"
                      alt="McLaren 720s"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 720s</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 12C - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/12C.png"
                      alt="McLaren 12C"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 12C</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 570s - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/570s_v2.png"
                      alt="McLaren 570s"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 570s/Spider/Coupe</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 650S/Spider - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/650s.png"
                      alt="McLaren 650S"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 650S/Spider</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 620R - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/620R.png"
                      alt="McLaren 620R"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 620R</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 540C Coupe - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/540c.png"
                      alt="McLaren 540C"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 540C Coupe</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 625C Coupe - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/625C_Coupe.png"
                      alt="McLaren 625C Coupe"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 625C Coupe</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 600LT Spider - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/600LT_Spider.png"
                      alt="McLaren 600LT Spider"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 600LT Spider</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 625C Spider - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/625c_spider.png"
                      alt="McLaren 625C Spider"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 625C Spider</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren 675LT Spider - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/675lt_spider.png"
                      alt="McLaren 675LT Spider"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren 675LT Spider</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren Artura - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/Artura.png"
                      alt="McLaren Artura"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren Artura</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren Elva - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/elva_1.png"
                      alt="McLaren Elva"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren Elva</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren GT 2023 - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/McLaren_GT.png"
                      alt="McLaren GT"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren GT</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren Senna - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/McLaren_Senna.png"
                      alt="McLaren Senna"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren Senna</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>

                  {/* McLaren Senna GTR - active */}
                  <div className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group">
                    <img
                      src="/site banners/McLaren_Senna_GTR.png"
                      alt="McLaren Senna GTR"
                      className="w-full h-64 object-cover transition duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex flex-col justify-end text-left p-4 text-white">
                      <h3 className="text-xl font-bold">McLaren Senna GTR</h3>
                      <p className="text-sm text-green-300">✔ Fully supported</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>



      {/* What Clients Say */}
      <section className="bg-white text-black py-12 px-6">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="text-4xl font-bold mb-12 text-[#140D4F]">What Clients Say</h2>
    <div className="grid md:grid-cols-3 gap-8">
      {[
        {
          name: "Liam R.",
          text: "DiagCode.AI helped me identify a rare ECU fault in under 2 minutes. Absolute game changer.",
        },
        {
          name: "Carlos D.",
          text: "I no longer need to search through 300-page manuals. This is the future of car repair.",
        },
        {
          name: "Noah K.",
          text: "Instant instructions, visuals, and confidence. Every mechanic should have this tool.",
        }
      ].map((t, i) => (
        <div key={i} className="bg-[#F4F4F4] rounded-xl p-6 shadow-md border border-gray-200 text-left">
          <p className="text-gray-700 mb-4 italic">"{t.text}"</p>
          <div className="text-sm font-semibold text-[#0267C1]">– {t.name}</div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* DiagCode.AI vs Traditional Methods */}
      <section className="bg-white text-black py-12 px-6">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="text-4xl font-bold mb-12 text-[#140D4F]">DiagCode.AI vs Traditional Methods</h2>
    <div className="grid md:grid-cols-2 gap-10 text-left">
      
      {/* Traditional */}
      <div className="bg-[#F4F4F4] p-6 rounded-xl shadow-sm border border-gray-200">
        <h3 className="text-xl font-semibold mb-3 text-[#FD1300]">Traditional Repair Manuals</h3>
        <ul className="text-gray-700 list-disc list-inside space-y-2">
          <li>Hundreds of pages to search through</li>
          <li>No visual explanation or AI logic</li>
          <li>Unstructured and outdated</li>
        </ul>
      </div>

      {/* DiagCode.AI */}
      <div className="bg-[#0267C1] p-6 rounded-xl shadow-md text-white">
        <h3 className="text-xl font-semibold mb-3">DiagCode.AI Experience</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>Instant AI-generated instructions</li>
          <li>Clear visuals and animations</li>
          <li>Search by symptoms, not codes</li>
        </ul>
      </div>

    </div>
  </div>
</section>

      {/* What's Next */}
      <section className="bg-white text-black py-12 px-6">
  <div className="max-w-4xl mx-auto text-center">
    <h2 className="text-4xl font-bold mb-8 text-[#140D4F] tracking-tight">What's Next</h2>
    <p className="text-gray-700 text-lg mb-12">
      We’re building the future of AI-powered diagnostics. Here's what’s coming soon:
    </p>
    <div className="grid sm:grid-cols-2 gap-6 text-left">
      {[
        { icon: "🔧", title: "Support for Porsche & Mercedes" },
        { icon: "📱", title: "Mobile App for real-time diagnostics" },
        { icon: "🧠", title: "Smart assistant memory for past fixes" },
        { icon: "🌍", title: "Multilingual repair instructions" }
      ].map((item, i) => (
        <div key={i} className="flex items-center gap-4 bg-[#F4F4F4] rounded-xl p-4 border border-gray-200 hover:border-[#0267C1] transition">
          <div className="text-3xl text-[#0267C1]">{item.icon}</div>
          <div className="text-[#140D4F] font-medium leading-snug">{item.title}</div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* CTA section */}
      <section className="bg-[#140D4F] text-white py-20 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Get Repairs Done Fast and Efficiently?
          </h2>
          <p className="text-lg mb-8 text-gray-200">
            Join DiagCode.AI and let smart diagnostics guide your next repair. Skip the guesswork—start with confidence.
          </p>
          <Link
            to="/register"
            className="inline-block px-8 py-3 bg-[#FD5003] hover:bg-[#e34700] text-white font-semibold text-lg rounded-md transition"
          >
            Get Started
          </Link>
        </div>
      </section>

<CookieNotice />
<footer className="bg-white border-t border-gray-200 text-gray-700 py-12 px-6 mt-20">
  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
    
    {/* Logo + tagline */}
    <div>
      <h2 className="text-[#140D4F] text-2xl font-bold tracking-tight">DiagCode.AI</h2>
      <p className="mt-2 text-sm text-gray-600">
        Smarter diagnostics.<br /> Faster repairs.<br /> Future-ready.
      </p>
    </div>

    {/* Navigation */}
    <div>
      <h4 className="text-[#140D4F] font-semibold mb-3 text-sm uppercase">Explore</h4>
      <ul className="space-y-2 text-sm">
        <li><a href="#top" className="hover:text-[#0267C1]">Home</a></li>
        <li><a href="#pricing" className="hover:text-[#0267C1]">Pricing</a></li>
        <li><a href="#how-it-works" className="hover:text-[#0267C1]">How it works</a></li>
        <li><a href="#brands" className="hover:text-[#0267C1]">Supported Brands</a></li>
      </ul>
    </div>

    {/* Legal */}
    <div>
      <h4 className="text-[#140D4F] font-semibold mb-3 text-sm uppercase">Legal</h4>
      <ul className="space-y-2 text-sm">
        <li><a href="/legal#terms" className="hover:text-[#0267C1]">Terms of Service</a></li>
        <li><a href="/legal#privacy" className="hover:text-[#0267C1]">Privacy Policy</a></li>
        <li><a href="/legal#cookies" className="hover:text-[#0267C1]">Cookies</a></li>
      </ul>
    </div>

    {/* Contact */}
    <div>
      <h4 className="text-[#140D4F] font-semibold mb-3 text-sm uppercase">Contact</h4>
      <p className="text-sm text-gray-600">Have questions or suggestions?</p>
      <a
        href="mailto:support@diagcode.ai"
        className="text-sm text-[#0267C1] hover:underline mt-2 inline-block"
      >
        info@diagcode.com
      </a>
      <br />
      <a
        href="mailto:diagcode.ai@gmail.com"
        className="text-sm text-[#0267C1] hover:underline mt-1 inline-block"
      >
        diagcode.ai@gmail.com
      </a>
    </div>
  </div> {/* ← липсваше това затваряне */}

  {/* Bottom line */}
  <div className="text-center text-xs text-gray-500 mt-10">
    &copy; {new Date().getFullYear()} DiagCode.AI. All rights reserved.
    <br className="block md:hidden" />
    <span className="italic">Powered by AI · Designed for the aftermarket revolution.</span>
  </div>
</footer>
    </div>
  );
}
